<div>
  <netz-page-heading>TP6 (2024)</netz-page-heading>
  <cca-summary [data]="summaryData()" />
</div>
